import { useEffect, useLayoutEffect, useState } from "react"
import { useParams } from "react-router"
import Showdown from "showdown"

import config from "../config"
import NewsList from "./NewsList"

export default function Article() {
  const { folder, hash } = useParams()

  const [content, setContent] = useState(null)
  const [newsList, setNewsList] = useState([])
  const [source, setSource] = useState("")
  const [articleLoaded, setArticleLoaded] = useState(null)
  const [newsListLoaded, setNewsListLoaded] = useState(false)

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0)
  }, [folder, hash])

  const converter = new Showdown.Converter()

  const objectPath = folder + "/" + hash

  function downloadArticle() {
    fetch(config["url-prefix"] + objectPath, {cache: "no-cache"}).then((response) => {
      return response.text()
    }).then(data => {
      let tmp = data.split("\n")
      document.title = config["title-prefix"] + tmp[0].slice(2)
      setSource(tmp.pop())
      data = tmp.join("\n").trim()
      setContent({__html: converter.makeHtml(data)})
      setArticleLoaded(hash)
    })
  }

  function downloadIndex() {
    fetch(config["url-prefix"] + "index.json", {cache: "no-cache"}).then((response) => {
      return response.json()
    }).then(data => {
      setNewsList(data)
      setNewsListLoaded(true)
    })
  }

  useEffect(() => {
    if (!articleLoaded || (articleLoaded !== hash)) {
      downloadArticle()
    }
    if (!newsListLoaded) {
      downloadIndex()
    }
    return () => {}
  }, [folder, hash, articleLoaded, newsListLoaded])

  return (
    <>
      <div className="content" dangerouslySetInnerHTML={content}></div>
      <p className="has-text-weight-light has-text-grey-light">
        Nguồn: <a href={source} className="has-text-grey-light">{source}</a>
      </p>
      <hr />
      <NewsList news={newsList} ignore={objectPath} />
    </>
  )
}
